import axios from 'axios';
import config from '../config';
import httpArcheo from "../helpers/http-archeo";
import removeCircularReferences from "../helpers/utils/removeCircularReferences";



export const createReperto = async (data) => {

  try {
    const sanitizedData = removeCircularReferences(data);
    const response = await httpArcheo.post("/api/private/v3/reperto/save", data);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const getReperti = async (filter) => {
  let path = `/api/private/v3/reperto/get?`;
  filter.forEach((f) => {
    if(f.value) path += `${f.key}=${f.value}&`;
  });
  try {
    const response = await httpArcheo.get(path);
    return response?.data;
  } catch (err) {
    throw err;
  }
};


export const getReperto = async (id) => {
  const path = `/api/private/v3/reperto/get/${id}`;
  try {
    const response = await httpArcheo.get(path);
    return response?.data?.reperto;
  } catch (err) {
    throw err;
  }
};


export const updateReperto = async (data) => {
  const sanitizedData = removeCircularReferences(data);
  const path = `/api/private/v3/reperto/update`;
  try {
    const response = await httpArcheo.put(path, sanitizedData);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const deleteReperto = async (id) => {
  const path = `/api/private/v3/reperto/delete/${id}`;
  try {
    const response = await httpArcheo.delete(path);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const updateBibliografie = async (data) => {
  const sanitizedData = removeCircularReferences(data);
  const path = `/api/private/v3/reperto/update/bibliografie`;
  try {
    const response = await httpArcheo.put(path, sanitizedData);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const updateRepertoEsposizione = async (data) => {
  const sanitizedData = removeCircularReferences(data);
  const path = `/api/private/v3/reperto/update/esposizione`;
  try {
    const response = await httpArcheo.put(path, sanitizedData);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

